import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { ComplaintParty } from 'libs/b2b/shared/src/lib/models/complaint-party';

@Component({
    selector: 'icc-complaint-user-preview-dialog',
    templateUrl: './complaint-user-preview-dialog.component.html',
    styleUrls: ['./complaint-user-preview-dialog.component.scss'],
})
export class ComplaintUserPreviewDialogComponent {

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            user: ComplaintParty;
            userType: string;
            responsibleUser: any;
            assignedUser: any;
        },
    ) {}

    close() {
        this.dialogRef.close();
    }
}
